import './styles.css.js';
import { Flex } from '@magnetic/flex';
import { useClassNames } from '@magnetic/hooks';
import { Text } from '@magnetic/text';
import React, { forwardRef, useContext } from 'react';
import { NavDrawerContentContext } from './content.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const RenderNavDrawerItemGroup = /* @__PURE__ */ __name(({ children, className, hideLabel, label, ...props }, ref) => {
  const { itemGroupSpacing } = useContext(NavDrawerContentContext);
  const classNames = useClassNames(
    "mds-nav-drawer-item-group",
    `mds-nav-drawer-margin-${itemGroupSpacing}`,
    className
  );
  return /* @__PURE__ */ React.createElement(Flex, {
    className: classNames,
    direction: "vertical",
    ref,
    ...props
  }, !hideLabel && /* @__PURE__ */ React.createElement(Text, {
    className: "mds-item-group-label",
    weight: "bold"
  }, label), children);
}, "RenderNavDrawerItemGroup");
const NavDrawerItemGroup = forwardRef(RenderNavDrawerItemGroup);
NavDrawerItemGroup.displayName = "Nav.Drawer.ItemGroup";

export { NavDrawerItemGroup, RenderNavDrawerItemGroup };
//# sourceMappingURL=item-group.js.map
